<template>
  <v-card>
    <v-card-title>
      {{organization.name}}
      <v-spacer></v-spacer>
      <v-btn class="ma-2" v-if="$root.$children[0].myRoles.includes('U') || $root.$children[0].isTechnicalAdmin" @click="dialogImport = true" color="success" small dark>import user</v-btn>
      <v-btn class="ma-2" @click="createPerson()" color="success" small dark>create user</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="identitiesList"
      :search="search"
      @click:row="editPerson"
      group-by="groupLetter"
      disable-pagination
      hide-default-footer
      class="elevation-1"
    >
      <template v-slot:top>
        <v-dialog v-model="dialogEdit" max-width="600">
          <v-form ref="userform" v-model="userformvalid" lazy-validation>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-toolbar dense color="primary" dark>
                        <v-toolbar-title>Details</v-toolbar-title>
                      </v-toolbar>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              dense
                              v-model="editedIdentity.person.email"
                              v-if="editedIdentity.id === '00000000-0000-0000-0000-000000000000'"
                              required
                              :rules="[v => !!v || 'this field is required']"
                              label="Email"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              dense
                              v-model="editedIdentity.person.email"
                              v-if="editedIdentity.id !== '00000000-0000-0000-0000-000000000000'"
                              label="Email (read-only)"
                              readonly
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="8" sm="4" md="3">
                            <v-text-field
                              dense
                              v-model="editedIdentity.person.firstname"
                              label="Firstname"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4" sm="2" md="2">
                            <v-text-field
                              dense
                              v-model="editedIdentity.person.initials"
                              label="Initials"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-text-field
                              dense
                              v-model="editedIdentity.person.surnamePrefix"
                              label="Prefix"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              dense
                              v-model="editedIdentity.person.surname"
                              label="Surname"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-menu
                              ref="birthdateMenu"
                              v-model="birthdateMenu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  dense
                                  v-model="editedIdentity.person.birthdate"
                                  label="Birthdate"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="editedIdentity.person.birthdate"
                                :max="new Date().toISOString().substr(0, 10)"
                                min="1950-01-01"
                                @change="saveBirthdate"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select
                              dense
                              :items="sexes"
                              item-text="name"
                              item-value="value"
                              v-model="editedIdentity.person.sex"
                              label="Sex"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" v-if="$root.$children[0].isTechnicalAdmin">
                            <v-select
                              dense
                              :items="organizations"
                              item-text="name"
                              item-value="id"
                              v-model="editedIdentity.organizationId"
                              required
                              :rules="[v => !!v || 'this field is required']"
                              label="Organization"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-card>
                      <v-toolbar dense color="primary" dark>
                        <v-toolbar-title>Roles</v-toolbar-title>
                      </v-toolbar>
                      <v-list dense>
                        <v-list-item
                          v-if="($root.$children[0].isTechnicalAdmin ? true : (editedIdentity.person.id != me.person.id))"
                          @click="if ($root.$children[0].isTechnicalAdmin || $root.$children[0].myRoles.includes('O')) editedIdentity.person.isOrganizationAdmin = !editedIdentity.person.isOrganizationAdmin"
                        >
                          <v-list-item-icon>
                            <v-icon
                              small
                              :color="(editedIdentity.person.isOrganizationAdmin ? 'success' : 'error')"
                            >{{getIcon(editedIdentity.person.isOrganizationAdmin)}}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Org Admin</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          v-if="($root.$children[0].isTechnicalAdmin ? true : (editedIdentity.person.id != me.person.id))"
                          @click="if ($root.$children[0].isTechnicalAdmin) editedIdentity.person.isUserAdmin = !editedIdentity.person.isUserAdmin"
                        >
                          <v-list-item-icon>
                            <v-icon
                              small
                              :color="(editedIdentity.person.isUserAdmin ? 'success' : 'error')"
                            >{{getIcon(editedIdentity.person.isUserAdmin)}}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>User Admin</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          v-if="($root.$children[0].isTechnicalAdmin ? true : (editedIdentity.person.id != me.person.id))"
                          @click="if ($root.$children[0].isTechnicalAdmin || $root.$children[0].myRoles.includes('O') || $root.$children[0].myRoles.includes('A')) editedIdentity.person.isEditor = !editedIdentity.person.isEditor"
                        >
                          <v-list-item-icon>
                            <v-icon
                              small
                              :color="(editedIdentity.person.isEditor ? 'success' : 'error')"
                            >{{getIcon(editedIdentity.person.isEditor)}}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Editor</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          v-if="($root.$children[0].isTechnicalAdmin ? true : (editedIdentity.person.id != me.person.id))"
                          @click="if ($root.$children[0].isTechnicalAdmin || $root.$children[0].myRoles.includes('A')) editedIdentity.person.isValidator = !editedIdentity.person.isValidator"
                        >
                          <v-list-item-icon>
                            <v-icon
                              small
                              :color="(editedIdentity.person.isValidator ? 'success' : 'error')"
                            >{{getIcon(editedIdentity.person.isValidator)}}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Validator</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="6"
                    v-if="identityProfiles && ($root.$children[0].isTechnicalAdmin ? true : (editedIdentity.person.id != me.person.id))"
                  >
                    <v-card>
                      <v-toolbar dense color="primary" dark>
                        <v-toolbar-title>Profiles</v-toolbar-title>
                      </v-toolbar>
                      <v-list dense>
                        <v-list-item
                          v-for="identityProfile in identityProfiles"
                          :key="identityProfile.id"
                          @click="linkProfilePerson(identityProfile.id)"
                        >
                          <v-list-item-icon>
                            <v-icon
                              small
                              :color="(personHasProfileId(identityProfile.id) ? 'success' : 'error')"
                            >{{getIcon(personHasProfileId(identityProfile.id))}}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>{{identityProfile.name}}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="closeDialog">Cancel</v-btn>
                <v-btn
                  v-if="$msal.data.user.idToken.roles && $msal.data.user.idToken.roles.includes('Admin') && editedIdentity.id !== '00000000-0000-0000-0000-000000000000'"
                  color="error"
                  text
                  @click="deleteIdentity"
                >Delete</v-btn>
                <v-btn color="success" text @click="savePerson">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogImport" max-width="500">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="baseUsers"
                      item-text="person.email"
                      item-value="id"
                      v-model="moveUserId"
                      label="Gebruiker"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogImport = false">Cancel</v-btn>
              <v-btn color="success" text @click="moveUser">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:group.header="{ group, items, headers, toggle }">
        <td @click="toggle" :colspan="headers.length">
          <strong>{{ group }}</strong>
          ({{ items.length }})
        </td>
      </template>
      <template v-slot:item.sex="props">{{getSex(props.item.person)}}</template>
      <template v-slot:item.created="props">{{displayDate(props.item.person.created)}}</template>
      <template v-slot:item.modified="props">{{displayDate(props.item.person.modified)}}</template>
      <template v-slot:item.lastSignIn="props">{{displayDate(props.item.person.lastSignIn)}}</template>
      <template v-slot:item.birthdate="props">{{displayDate(props.item.person.birthdate)}}</template>
      <template v-slot:item.isOrganizationAdmin="props">
        <v-icon
          :color="(props.item.person.isOrganizationAdmin ? 'success' : 'error')"
        >{{getIcon(props.item.person.isOrganizationAdmin)}}</v-icon>
      </template>
      <template v-slot:item.isUserAdmin="props">
        <v-icon
          :color="(props.item.person.isUserAdmin ? 'success' : 'error')"
        >{{getIcon(props.item.person.isUserAdmin)}}</v-icon>
      </template>
      <template v-slot:item.isEditor="props">
        <v-icon
          :color="(props.item.person.isEditor ? 'success' : 'error')"
        >{{getIcon(props.item.person.isEditor)}}</v-icon>
      </template>
      <template v-slot:item.isValidator="props">
        <v-icon
          :color="(props.item.person.isValidator ? 'success' : 'error')"
        >{{getIcon(props.item.person.isValidator)}}</v-icon>
      </template>
      <template v-slot:no-data>
        <p>No results</p>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: ["me", "organization", "organizations"],
  data: () => ({
    submitStatus: null,
    identities: [],
    identityProfiles: [],
    baseUsers: [],
    headers: [],
    identitiesList: [],
    userformvalid: false,
    dialogImport: false,
    dialogEdit: false,
    birthdateMenu: false,
    moveUserId: null,
    editedIndex: -1,
    editedIdentity: {
      id: null,
      organizationId: null,
      person: {
        firstname: "",
        surnamePrefix: "",
        surname: "",
        initials: "",
        birthdate: "",
        sex: 0,
        isOrganizationAdmin: false,
        isUserAdmin: false,
        isEditor: false,
        isValidator: false,
        identityProfilePersons: []
      }
    },
    defaultIdentity: {
      id: "00000000-0000-0000-0000-000000000000",
      organizationId: null,
      person: {
        id: "00000000-0000-0000-0000-000000000000",
        email: "",
        firstname: "",
        surnamePrefix: "",
        surname: "",
        initials: "",
        birthdate: "",
        sex: 0,
        isOrganizationAdmin: false,
        isUserAdmin: false,
        isEditor: false,
        isValidator: false,
        identityProfilePersons: []
      }
    },
    sexes: [
      { value: 0, name: "Unknown" },
      { value: 1, name: "Male" },
      { value: 2, name: "Female" },
      { value: 3, name: "Unspecified" }
    ],
    search: ""
  }),
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
    birthdateMenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  methods: {
    personHasProfileId(identityProfileId) {
      return this.editedIdentity.person.identityProfilePersons.find(x => {
        return x.identityProfileId === identityProfileId;
      });
    },
    linkProfilePerson(identityProfileId) {
      if (!this.editedIdentity.person.identityProfilePersons) {
        this.editedIdentity.person.identityProfilePersons = {
          identityProfile: null,
          personId: this.editedIdentity.person.id,
          identityProfileId: identityProfileId
        };
      } else {
        var index = this.personHasProfileId(identityProfileId);
        if (!index) {
          this.editedIdentity.person.identityProfilePersons.push({
            identityProfile: null,
            personId: this.editedIdentity.person.id,
            identityProfileId: identityProfileId
          });
        } else {
          var removeIndex = this.editedIdentity.person.identityProfilePersons.findIndex(
            x => {
              return x.identityProfileId === identityProfileId;
            }
          );
          this.editedIdentity.person.identityProfilePersons.splice(
            removeIndex,
            1
          );
        }
      }
    },
    saveBirthdate(date) {
      this.$refs.birthdateMenu.save(date);
    },
    displayDate(date) {
      if (!date) return "-";
      return this.$moment(date).format("DD-MM-YYYY");
    },
    displayName(person) {
      var name = person.surname;
      if (person.surnamePrefix) name = name + ", " + person.surnamePrefix;
      if (person.firstname) name = name + ", " + person.firstname;
      if (person.initials) name = name + " (" + person.initials + ")";
      return name;
    },
    getSex(person) {
      var sex = this.sexes.find(x => x.value == person.sex);
      if (sex) return sex.name;
      else {
        return '';
      }
    },
    getIcon(val) {
      return val ? "mdi-check-bold" : "mdi-checkbox-blank-circle-outline";
    },
    createPerson() {
      this.editedIndex = -1;
      Object.assign(this.editedIdentity, this.defaultIdentity);
      this.dialogEdit = true;
    },
    editPerson(item) {
      this.editedIndex = this.identities.indexOf(item);
      Object.assign(this.editedIdentity, item);
      this.dialogEdit = true;
    },
    closeDialog() {
      this.$refs.userform.reset();
      this.dialogImport = false;
      this.dialogEdit = false;
      setTimeout(() => {
        Object.assign(this.editedIdentity, this.defaultIdentity);
        this.editedIndex = -1;
      }, 300);
      this.getEmployees();
    },
    moveUser() {
      this.$http
        .post("api/identities/move/" + this.moveUserId, {
          id: this.organization.id
        })
        .then(request => {
          if (request.status == 200) {
            this.getEmployees();
          }
          this.closeDialog();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1900", e);
          this.closeDialog();
        });
    },
    savePerson() {
      if (this.$refs.userform.validate()) {
        if (!this.$root.$children[0].isTechnicalAdmin)
          this.editedIdentity.organizationId = this.organization.id;
        this.$http
          .post(
            "api/identities/person/" + this.editedIdentity.id,
            this.editedIdentity
          )
          .then(request => {
            if (request.status == 200) {
              this.getEmployees();
            }
            this.closeDialog();
          })
          .catch(e => {
            this.$root.$children[0].$emit("display-error", "1901", e);
          });
      }
      else{
        this.$root.$children[0].$emit("display-error", "1902", "userform invalid");
      }
    },
    deleteIdentity() {
      this.$http
        .delete("api/person/" + this.editedIdentity.person.id + '/organization/' + this.editedIdentity.organizationId)
        .then(request => {
          if (request.status == 200) {
            this.getEmployees();
          }
          this.closeDialog();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1903", e);
        });
    },
    updateList() {
      this.identitiesList = [];
      if (this.identities && this.identities.length > 0) {
        this.headers = [
          { text: "Name", value: "person.displayName" },
          { text: "Birthdate", value: "birthdate" },
          { text: "Sex", value: "sex" },
          { text: "E-mail", value: "person.email" },
          { text: "Created", value: "created" },
          { text: "Modified", value: "modified" },
          { text: "Last seen", value: "lastSignIn" },
          { text: "Org Admin", value: "isOrganizationAdmin" },
          { text: "User Admin", value: "isUserAdmin" },
          { text: "Editor", value: "isEditor" },
          { text: "Validator", value: "isValidator" }
        ];
        this.identities.forEach(i => {
          let newIdentity = {
            id: i.id,
            organizationId: i.organizationId,
            groupLetter: i.person.surname
              ? i.person.surname.substring(0, 1)
              : "#",
            person: {
              id: i.person.id,
              displayName: this.displayName(i.person),
              firstname: i.person.firstname,
              surnamePrefix: i.person.surnamePrefix,
              surname: i.person.surname,
              birthdate: i.person.birthdate,
              sex: i.person.sex,
              email: i.person.email,
              created: i.person.created,
              modified: i.person.modified,
              lastSignIn: i.person.lastSignIn,
              isUserAdmin: i.person.isUserAdmin,
              isOrganizationAdmin: i.person.isOrganizationAdmin,
              isEditor: i.person.isEditor,
              isValidator: i.person.isValidator,
              identityProfilePersons: i.person.identityProfilePersons
            }
          };
          this.identitiesList.push(newIdentity);
        });
      }
    },
    getEmployees() {
      this.$http
        .get("api/person/organization/" + this.organization.id)
        .then(request => {
          this.identities = request.data;
          this.getBaseEmployees();
          this.updateList();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1904", e);
        });
    },
    getIdentityProfiles() {
      this.$http
        .get("api/identityprofiles/active")
        .then(request => {
          this.identityProfiles = request.data;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1905", e);
        });
    },
    getBaseEmployees() {
      this.$http
        .get("api/identities/baseorganization/")
        .then(request => {
          this.baseUsers = request.data;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1906", e);
        });
    }
  },
  mounted: function() {
    this.getIdentityProfiles();
    this.getEmployees();
  }
};
</script>